import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
    group: {
        marginLeft: theme.spacing(2),
    },
    controlsRow: {
        marginBottom: theme.spacing(2),
        display: 'flex',
        gap: theme.spacing(2),
        alignItems: 'center',
        flexWrap: 'wrap',
    },
    card: {
        marginBottom: theme.spacing(2),
    },
    thresholdCardSpacer: {
        marginBottom: theme.spacing(2),
    },
    cbqosHeader: {
        marginLeft: theme.spacing(2),
        marginBottom: theme.spacing(1),
        fontWeight: 600,
    },
    thresholdUnits: {
        fontWeight: 400,
        color: theme.palette.text.secondary,
    },
    cbqosOptionSelect: {
        minWidth: 180,
    },
    cbqosMetricLabel: {
        width: 200,
        minWidth: 200,
        maxWidth: 200,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        textAlign: 'right',
        paddingRight: 20,
    },
}));
